import { z } from 'zod';
import { INTEGRATION_CONNECTOR_TYPES } from '../constants/integrationConnectors.js';
export const integrationConnectorTypeSchema = z.enum(INTEGRATION_CONNECTOR_TYPES);
export const integrationStatusSchema = z.enum(['pending', 'active', 'error', 'disabled']);
export const integrationsListQuerySchema = z.object({
    project_id: z.string().uuid(),
});
export const integrationCreateSchema = z.object({
    project_id: z.string().uuid(),
    connector_type: integrationConnectorTypeSchema,
    config: z.record(z.string(), z.unknown()).default({}),
    credentials: z.string().min(20),
});
export const integrationUpdateSchema = z.object({
    config: z.record(z.string(), z.unknown()).optional(),
    status: integrationStatusSchema.optional(),
});
export const integrationCredentialsSchema = z.object({
    credentials: z.string().min(20),
});
//# sourceMappingURL=integration.js.map